<div *ngIf="auth" style="position: relative; z-index: 1">
	<header class="header">
		<div class="topBar" [style.backgroundColor]="colorBar"></div>

		<div class="icon-menu" appExpandSidebar (click)="menuClick()">

			<div class="icons">
				<fa-icon *ngIf="slideMenu=='slide-open'" class="flecha" icon="arrow-left"></fa-icon>
				<fa-icon *ngIf="slideMenu=='slide-open'" class="bars" icon="bars"></fa-icon>
				<fa-icon *ngIf="slideMenu=='slide-close'" icon="bars"></fa-icon>
			</div>


			<div class="title">{{ title }}</div>
		</div>

		<div class="header-user" (clickOutside)="onClickedOutside($event)">
			<div class="profile" (click)="profileInfo()">
				<img src="{{ imgSrc }}" class="profile-img">
				<h6 class="link">{{ user.name }}</h6>
			</div>

			<div class="profile-content" *ngIf="openProfile">
				<div class="flex">
					<img src="{{ imgSrc }}" class="img-profile">
					<div class="profile-info">
						<h6>{{ user.name }}</h6>
						<p>{{ user.username }}</p>
					</div>
				</div>

				<hr>

				<button class="btn btn-block dangerButton" (click)="logOut()">
					<fa-icon icon="power-off" style="margin-right: 5px;"></fa-icon>
					{{ 'button.logout' | translate }}
				</button>
			</div>
		</div>
	</header>

	<div class="content">
		<div class="black-screen" (click)="menuClick()"></div>
		<app-loading></app-loading>
		<router-outlet></router-outlet>

	</div>

	<aside class="sidebar">
		<nav class="nav-menu">
			<div class="sidebar-header d-flex justify-content-between">
				<div class="topBar" [style.backgroundColor]="colorBar"></div>
				<div class="figure" style="border-top: 5px solid #552f78;">
					<img src="./assets/img/logo.png">
				</div>
			</div>
			<ul>
				<div *ngFor="let menu of menu">

					<li *ngIf="menu.children.length == 0" class="close-menu">
						<a [routerLink]="[menu.url]" routerLinkActive="active-link">
							<div class="icon">
								<i [class]="menu.icon_class"></i>
							</div>
							<h6>{{ menu.title }}</h6>
						</a>
					</li>

					<li appExpandMenu *ngIf="menu.children.length > 0" class="close-menu">
						<a>
							<div class="icon icon-none">
								<fa-icon icon="home"></fa-icon>
							</div>
							<h6 class="arrow-down" id="{{menu.id}}">{{ menu.title }}</h6>
						</a>
					</li>

					<ul class="nav-drown submenu expand-{{menu.id}}" *ngIf="menu.children.length > 0">
						<li *ngFor="let submenu of menu.children">
							<a [routerLink]="[submenu.url]" routerLinkActive="active-link">
								<h6>{{ submenu.title }}</h6>
							</a>
						</li>
					</ul>

				</div>
			</ul>
		</nav>
	</aside>

	<footer class="footer fixed-bottom">
		<div class="footer1">
			<img src="{{imgUrl }}">
		</div>
		<div class="footer2">
			<h6>{{ 'rights' | translate }}</h6>
		</div>
	</footer>

	<div style="display: none;">
		<app-modal-logout (dismiss)="'dismiss'" (close)="'close'"></app-modal-logout>
	</div>
</div>